










































































































































































import { mapState } from 'vuex';
import { fetchEmailTemplates } from '@adobe/edex/frontend/api/course';
import CourseTemplateForm from '@adobe/edex/frontend/views/course/course-notification-template-form.vue';
import * as notificationAPI from '@adobe/edex/frontend/api/notification';
import { isEmpty } from 'lodash-es';
import { $t } from '@adobe/edex/ui/shared/config/i18n';

enum TemplateNames {
  passed = 'Course Passed',
  enrolled = 'Course Enrollment Confirmation',
  firstReminder = 'Course First Reminder',
  secondReminder = 'Course Second Reminder',
  lastReminder = 'Course Last Reminder',
}

const getInitialState = () => ({
  currentTab: 'enrolled',
  passedTemplate: null,
  enrolledTemplate: null,
  firstReminderTemplate: null,
  secondReminderTemplate: null,
  lastReminderTemplate: null,
  firstThresholdDay: null,
  secondThresholdDay: null,
  lastThresholdDay: null,
  thresholdSave: false,
  loading: false,
  error: false,
  firstThresholdError: false,
  secondThresholdError: false,
  lastThresholdError: false,
  thresholdExists: [false, false, false],
});

export default {
  data() {
    return getInitialState();
  },
  components: {
    CourseTemplateForm,
  },
  async created() {
    this.checkPermissions();
    this.loading = true;
    const FIRST_THRESHOLD = 60;
    const FIRST_DEFAULT = 7;
    const SECOND_DEFAULT = 14;
    const LAST_DEFAULT = 60;
    const { data, status } = await fetchEmailTemplates(this.course.id);

    if (status === 200) {
      data.forEach((element) => {
        switch (element.templateName) {
          case TemplateNames.passed:
            this.passedTemplate = element;
            break;
          case TemplateNames.enrolled:
            this.enrolledTemplate = element;
            break;
          case TemplateNames.firstReminder:
            this.firstReminderTemplate = element;
            this.firstThresholdDay = element.thresholdDay;
            this.thresholdExists[0] = true;
            break;
          case TemplateNames.secondReminder:
            this.secondReminderTemplate = element;
            this.secondThresholdDay = element.thresholdDay;

            this.thresholdExists[1] = true;
            break;
          case TemplateNames.lastReminder:
            this.lastReminderTemplate = element;
            this.lastThresholdDay = element.thresholdDay;
            this.thresholdExists[2] = true;
            break;
          default:
            break;
        }
      });
      if (!this.thresholdExists[0]) {
        this.firstThresholdDay = 7;
      }
      if (!this.thresholdExists[1]) {
        this.secondThresholdDay = 14;
      }
      if (!this.thresholdExists[2]) {
        this.lastThresholdDay = 60;
      }
      this.checkSaves();
    } else {
      this.error = true;
    }
    this.loading = false;
  },
  beforeRouteEnter(_, __, next) {
    return next((vm: any) => {
      vm.checkPermissions();
    });
  },
  computed: {
    ...mapState('course', ['course']),
    ...mapState('member', ['member']),
    description() {
      switch (this.currentTab) {
        case 'passed':
          return 'Required email to all enrollees upon completion.';
        case 'enrolled':
          return 'Required email to all enrollees upon enrollment.';
        default:
          return 'Optional reminder to enrollees (not in review, not graduated) with no activity in the last ';
      }
    },
    tooltipText() {
      switch (this.currentTab) {
        case 'firstReminder':
          return 'Enter a number less than 60.';
        case 'secondReminder':
          return 'Enter a number less than 60 and greater than first reminder';
        case 'lastReminder':
          return 'Enter a number no more than 365 and greater than second reminder';
        default:
          return 'None!';
      }
    },
  },
  methods: {
    handleUpdate({ name, data }) {
      switch (name) {
        case TemplateNames.passed:
          this.passedTemplate = data;

          break;

        case TemplateNames.enrolled:
          this.enrolledTemplate = data;
          break;

        case TemplateNames.firstReminder:
          this.firstReminderTemplate = data;
          this.thresholdExists[0] = data.thresholdDay;
          break;
        case TemplateNames.secondReminder:
          this.secondReminderTemplate = data;
          this.thresholdExists[1] = data.thresholdDay;
          break;
        case TemplateNames.lastReminder:
          this.lastReminderTemplate = data;
          this.thresholdExists[2] = data.thresholdDay;
          break;
        default:
          break;
      }
    },
    handleEditDays(event) {
      this.thresholdSave = true;
      let query;
      switch (this.currentTab) {
        case 'firstReminder': {
          query = '#firstInput';
          break;
        }
        case 'secondReminder': {
          query = '#secondInput';
          break;
        }

        case 'lastReminder': {
          query = '#lastInput';
          break;
        }

        default:
          query = '#firstInput';
          break;
      }
      const inputBox = document.querySelector<HTMLInputElement>(query);
      inputBox.select();
      inputBox.removeAttribute('readonly');
    },
    async handleSaveDays() {
      this.loading = true;
      let template;
      let thresholdDay;
      switch (this.currentTab) {
        case 'firstReminder': {
          template = this.firstReminderTemplate;
          thresholdDay = parseInt(this.firstThresholdDay, 10);
          this.checkSaves();
          break;
        }
        case 'secondReminder': {
          template = this.secondReminderTemplate;
          thresholdDay = parseInt(this.secondThresholdDay, 10);
          this.checkSaves();
          break;
        }
        case 'lastReminder': {
          template = this.lastReminderTemplate;
          thresholdDay = parseInt(this.lastThresholdDay, 10);
          this.checkSaves();
          break;
        }
        default:
          break;
      }
      this.title = template;
      if (
        !(
          (this.currentTab === 'firstReminder' && this.firstThresholdError) ||
          (this.currentTab === 'secondReminder' && this.secondThresholdError) ||
          (this.currentTab === 'lastReminder' && this.lastThresholdError)
        ) &&
        !isEmpty(template)
      ) {
        await notificationAPI.update(template.id, { thresholdDay });
      }

      this.loading = false;
      this.thresholdSave = false;
    },

    checkSaves() {
      let thresholdDay;
      thresholdDay = parseInt(this.firstThresholdDay, 10);
      if (
        thresholdDay >= 60 ||
        (thresholdDay >= parseInt(this.secondThresholdDay, 10) && this.thresholdExists[1]) ||
        (thresholdDay >= parseInt(this.lastThresholdDay, 10) && this.thresholdExists[2])
      ) {
        this.firstThresholdError = true;
      } else {
        this.firstThresholdError = false;
      }

      thresholdDay = parseInt(this.secondThresholdDay, 10);

      if (
        thresholdDay >= 60 ||
        (thresholdDay <= parseInt(this.firstThresholdDay, 10) && this.thresholdExists[0]) ||
        (thresholdDay >= parseInt(this.lastThresholdDay, 10) && this.thresholdExists[2])
      ) {
        this.secondThresholdError = true;
      } else {
        this.secondThresholdError = false;
      }

      thresholdDay = parseInt(this.lastThresholdDay, 10);

      if (
        thresholdDay > 365 ||
        (thresholdDay <= parseInt(this.secondThresholdDay, 10) && this.thresholdExists[1]) ||
        (thresholdDay <= parseInt(this.firstThresholdDay, 10) && this.thresholdExists[0])
      ) {
        this.lastThresholdError = true;
      } else {
        this.lastThresholdError = false;
      }
    },

    checkPermissions() {
      // R E D I R E C T   N O N - A D M I N   T O   A B O U T
      // Doesn't allow non-admins to navigate to templates page
      if (!this.member?.isAdmin) {
        this.$router.push(
          this.rDecor({
            name: 'course-about',
            params: {
              vanityURL: this.course.vanityURL,
            },
          })
        );
      }
    },

    URLtext() {
      if (this.currentTab === 'passed') {
        return this.course.assets?.images?.passed?.url || null;
      } else {
        return this.course.assets?.images?.enrolled?.url || null;
      }
    },

    mobileURLtext() {
      const url: string = this.URLtext();
      if (url) {
        const lastObliqueIndex = url.lastIndexOf('/');
        // alert(url.substring(0, lastObliqueIndex) + '/560x315/webp' + url.substring(lastObliqueIndex));
        return url.substring(0, lastObliqueIndex) + '/560x315/webp' + url.substring(lastObliqueIndex);
      }
    },
  },
};
